import { request } from '@aqx-core/common/request';

import {
  IBulkActionResponse,
  IBulkDeletePriceAlertsParams,
  ICreatePriceAlertParams,
  IDeletePriceAlertParams,
  IGetPriceAlertsParams,
  IInitSymbolPriceAlerts,
  IPriceAlert,
  IPriceAlertConfig,
  IUpdatePriceAlertParams
} from '../model';

export default {
  getAlerts: (params: IGetPriceAlertsParams, signal?: AbortSignal) =>
    request.get<IInitSymbolPriceAlerts[]>('/api/user/alert/v1', { params, signal }),
  getAlertsBySymbol: (symbol: string, signal?: AbortSignal) =>
    request.get<IInitSymbolPriceAlerts>(`/api/user/alert/v1/${symbol}`, { signal }),
  createAlert: (params: ICreatePriceAlertParams) => request.post<IPriceAlert>('/api/user/alert/v1', params),
  updateAlert: (params: IUpdatePriceAlertParams) => request.put<IPriceAlert>('/api/user/alert/v1', params),
  deleteAlert: (params: IDeletePriceAlertParams) => request.delete<string>('/api/user/alert/v1', { params }),
  bulkDeleteAlerts: (params: IBulkDeletePriceAlertsParams) =>
    request.delete<IBulkActionResponse>('/api/user/alert/v1/bulk', { data: params }),
  getAlertConfig: (signal?: AbortSignal) => request.get<IPriceAlertConfig>('/api/user/alert/v1/config', { signal })
};
